export default function Matplotlib_Intro() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MatplotlibIntro Component</h1>
      <p>This is the MatplotlibIntro component.</p>
    </div>
  );
}
